"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Tue Mar 05 2019
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var ValidationResultConverter_1 = require("../../core/model/errors/conversions/ValidationResultConverter");

var ResourceLockResultDTOConverter_1 = require("../../resource-lock/conversions/ResourceLockResultDTOConverter");

var SimulationFindCreateDTO_1 = require("../model/SimulationFindCreateDTO");

var ForecastSimulationConflictDTOConverter_1 = require("./ForecastSimulationConflictDTOConverter");

var SimulationFindCreateDTOConverter_1 = require("./SimulationFindCreateDTOConverter");
/**
 * @author BPo
 * @author Tomas Leity
 */


var SimulationFindCreateDTOConverterImpl =
/*#__PURE__*/
function (_SimulationFindCreate) {
  _inherits(SimulationFindCreateDTOConverterImpl, _SimulationFindCreate);

  function SimulationFindCreateDTOConverterImpl(forecastSimulationConflictDTOConverter, resourceLockResultDTOConverter, validationResultConverter) {
    var _this;

    _classCallCheck(this, SimulationFindCreateDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimulationFindCreateDTOConverterImpl).call(this));
    _this.forecastSimulationConflictDTOConverter = forecastSimulationConflictDTOConverter;
    _this.resourceLockResultDTOConverter = resourceLockResultDTOConverter;
    _this.validationResultConverter = validationResultConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SimulationFindCreateDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SimulationFindCreateDTO_1.SimulationFindCreateDTO(conversions.toClassReferenceId(source.promotionId), conversions.toClassReferenceId(source.simulationId), conversions.toClassReferenceId(source.sessionId), conversions.asObjectOpt(source, 'conflicts', function (doc) {
        return _this2.forecastSimulationConflictDTOConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'lock', function (doc) {
        return _this2.resourceLockResultDTOConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'validationResult', function (doc) {
        return _this2.validationResultConverter.toObject(doc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      var result = {};
      Object.assign(result, {
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        simulationId: conversions.toDocumentReferenceId(source.simulationId),
        sessionId: conversions.toDocumentReferenceId(source.sessionId),
        conflicts: conversions.asObjectOpt(source, 'conflicts', function (dto) {
          return _this3.forecastSimulationConflictDTOConverter.toDocument(dto, conversions);
        }),
        lock: conversions.asObjectOpt(source, 'lock', function (dto) {
          return _this3.resourceLockResultDTOConverter.toDocument(dto, conversions);
        }),
        validationResult: conversions.asObjectOpt(source, 'validationResult', function (dto) {
          return _this3.validationResultConverter.toDocument(dto, conversions);
        })
      });
      return result;
    }
  }]);

  return SimulationFindCreateDTOConverterImpl;
}(SimulationFindCreateDTOConverter_1.SimulationFindCreateDTOConverter);

SimulationFindCreateDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ForecastSimulationConflictDTOConverter_1.ForecastSimulationConflictDTOConverter, ResourceLockResultDTOConverter_1.ResourceLockResultDTOConverter, ValidationResultConverter_1.ValidationResultConverter])], SimulationFindCreateDTOConverterImpl);
exports.SimulationFindCreateDTOConverterImpl = SimulationFindCreateDTOConverterImpl;